import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import validationSchema from './validations';
import translations from './translations';

const CouponForm = ({ onCancel, onSubmit }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      coupon: '',
    },
    onCancel,
    onSubmit,
  });

  return (
    <Form form={form} submitLabel={intl.formatMessage(translations.actions.add)}>
      <TextField name="coupon" label={intl.formatMessage(translations.fields.coupon)} autoFocus />
    </Form>
  );
};

CouponForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

CouponForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
};

export default CouponForm;
